import {ObjectId} from 'bson';
import superjson from 'superjson';

superjson.registerCustom<ObjectId, string>(
  {
    isApplicable: (v): v is ObjectId => v instanceof ObjectId,
    serialize: (v) => v.toString(),
    deserialize: (v) => new ObjectId(v),
  },
  'ObjectId'
);

export {superjson};
